import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './routes/Home';
import { ContentPage } from './routes/ContentPage';
import { SkiffShare } from './routes/SkiffShare';
import { MilestoneShare } from './routes/MilestoneShare';
import { ProfileShare } from './routes/ProfileShare';
import { NotFound } from './routes/NotFound';
import { Staff } from './routes/Staff';

export const router = createBrowserRouter([
  // Internal dashboard: no marketing Layout (header/footer), no OG injection.
  // The server serves index.html for it via the SPA fallback, and the page adds
  // its own noindex. Access is enforced by /api/admin/overview, not here.
  { path: '/staff', element: <Staff tab="metrics" /> },
  { path: '/staff/reports', element: <Staff tab="reports" /> },
  { path: '/staff/deletions', element: <Staff tab="deletions" /> },
  {
    element: <Layout />,
    errorElement: (
      <Layout>
        <NotFound />
      </Layout>
    ),
    children: [
      { path: '/', element: <Home /> },
      // NO /privacy, /terms, /support or /delete-account.
      //
      // SK-189 moved the four store-required pages to skiffs.app and
      // `pb_public_fallback.pb.js` now 301s those paths, so a request never
      // reaches React. Keeping the routes would leave the same copy claimed by
      // two hosts — the exact split-signal problem the move exists to fix — and
      // would rot silently, since nothing would ever render them.
      //
      // If you are tempted to add one back: put the page in `site/` instead.
      { path: '/p/:slug', element: <ContentPage /> },
      { path: '/s/:code', element: <SkiffShare /> },
      { path: '/s/:code/m/:messageId', element: <MilestoneShare /> },
      { path: '/u/:userId', element: <ProfileShare /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
